import instance from '@apis/instance';
import {
  GetOrderLogsParams, OrderLogResponse, OrderLogRow, RecentOrdersResponse,
} from '@models/order/orderLog';
import { SliceResponse } from '@models/page';

class OrderLogApi {
  static getOrderLogs(params: GetOrderLogsParams):Promise<SliceResponse<OrderLogRow>> {
    return instance.get('/orders', { params });
  }

  static getOrderLog(orderNo: string) : Promise<OrderLogResponse> {
    return instance.get(`/order/${orderNo}`);
  }
}

export default OrderLogApi;
